import React from "react";
import { LongTextLabel, VerifiedBy } from "@sscs/ui";
import RenderChildrenWrapper from "../../RenderChildrenWrapper";
import styles from "./name.module.scss";
const Name = ({ component, nameWrapper }) => {
    var _a;
    return (React.createElement("div", { className: styles.root },
        React.createElement(VerifiedBy, { verified: (_a = component.verified) !== null && _a !== void 0 ? _a : false }),
        component.type === "id" ? (React.createElement(RenderChildrenWrapper, { wrapper: nameWrapper },
            React.createElement(LongTextLabel, { label: component.name }))) : (React.createElement(LongTextLabel, { label: component.name }))));
};
export default Name;
//# sourceMappingURL=Name.js.map